export default __webpack_public_path__ + "static/media/menu_1.19a47499.png";